import { ICONS } from '~/constants/icons';
import { DataFieldConfig } from './data-builder';
import { NestedHome } from '@habity/types';
import { capitalize } from 'lodash';
import { isFarm } from '@habity/types/vitec/assertions';
import { EstateModelsLand } from '@habity/types/vitec/common/estateModelsLand';

const getLandIcon = (name: string) => {
  if (name.toLowerCase().includes('åker'))
    return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  if (name.toLowerCase().includes('skog'))
    return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  if (name.toLowerCase().includes('betesmark'))
    return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  if (name.toLowerCase().includes('äng')) return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  if (name.toLowerCase().includes('mark'))
    return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  if (name.toLowerCase().includes('tomt'))
    return ICONS.ROOM_DESCRIPTIONS.GARDEN;
  return ICONS.ROOM_DESCRIPTIONS.OTHER;
};

export const getLandsFromHome = (context: { home: NestedHome }) => {
  const { home } = context;
  const { provider_data, provider_type } = home || {};
  if (!provider_data || !provider_type) return [];

  if (isFarm(provider_data, provider_type)) {
    // @ts-ignore
    const { lands } = provider_data || {};
    return lands;
  }

  return [];
};

// Create dynamic fields based on lands data
export const createLandsFields = (context: {
  home: NestedHome;
}): DataFieldConfig[] => {
  const lands = getLandsFromHome(context);

  if (!lands || lands.length === 0) return [];

  // If lands is an array of land objects with name and description
  if (
    Array.isArray(lands) &&
    lands.length > 0 &&
    typeof lands[0] === 'object' &&
    lands[0].name
  ) {
    return lands.map((land: EstateModelsLand, index: number) => ({
      key: `land_${index}`,
      label: capitalize(land.name || `Mark ${index + 1}`),
      icon: getLandIcon(land.name || ''),
      getValue: () => land.description || '',
      condition: () => true, // Always include if land exists
    }));
  }

  // If lands is a simple value (fallback)
  return [
    {
      key: 'lands_fallback',
      label: 'Marker',
      icon: getLandIcon(''),
      getValue: () => lands?.toString() || '',
      condition: () => true,
    },
  ];
};

export const landsFields: DataFieldConfig[] = [];
